module.exports = __webpack_public_path__ + "img/favicon.9f6728dc.svg";